export function getGlobalPageDriverUrl(page: string): string {
	const notFound = '/404.html';

	if (!page) {
		console.error('Page is not defined');
		return notFound;
	}

	const globalPageDrivers = window.lt.globalPageDrivers?.global;

	if (!globalPageDrivers) {
		console.error(`Global page drivers don't exist`);
		return notFound;
	}

	if (!globalPageDrivers[page]) {
		console.error(`Page ${page} doesn't exist in global page drivers`);
		return notFound;
	}

	return globalPageDrivers[page];
}
